'use client';

import { c as _c } from "react/compiler-runtime";
import { useTheme } from 'next-themes';
import { useSyncExternalStore } from 'react';
import DarkMode from '../../icons/DarkMode';
import LightMode from '../../icons/LightMode';
import Settings from '../../icons/Settings';
import { cn } from '../../utils/cn';
import { SegmentedControlItem, SegmentedControlList } from '../_base/SegmentedControl';
import { Tabs } from '../_base/Tabs';
const subscribeNoop = () => () => {};
interface ThemeSegmentedControlProps {
  className?: string;
}
export function ThemeSegmentedControl(t0) {
  const $ = _c(11);
  const {
    className
  } = t0;
  const {
    theme,
    setTheme
  } = useTheme();
  const isHydrated = useSyncExternalStore(subscribeNoop, _temp, _temp2);
  const t1 = isHydrated ? theme ?? "" : "";
  let t2;
  if ($[0] !== setTheme) {
    t2 = value => {
      if (value) {
        setTheme(value);
      }
    };
    $[0] = setTheme;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = cn("gap-0", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SegmentedControlItem value="system" aria-label="Auto mode" className="flex-1"><Settings className="size-5" /></SegmentedControlItem>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SegmentedControlItem value="dark" aria-label="Dark mode" className="flex-1"><DarkMode className="size-5" /></SegmentedControlItem>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SegmentedControlList className="w-full">{t4}{t5}<SegmentedControlItem value="light" aria-label="Light mode" className="flex-1"><LightMode className="size-5" /></SegmentedControlItem></SegmentedControlList>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t7 = <Tabs value={t1} onValueChange={t2} className={t3}>{t6}</Tabs>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}